/* eslint-disable react-hooks/exhaustive-deps */
import {
	Box,
	Button,
	FormControl,
	FormLabel,
	Heading,
	Img,
	Input,
	Link,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
	useDisclosure,
	useToast,
} from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import { Link as RouterLink, useHistory } from "react-router-dom";
import firebase from "../firebase";
import theme from "../helpers/theme";

const validateEmail = email => {
	const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
};

export const Register = () => {
	const toast = useToast();

	const emailRef = useRef(null);
	const passwordRef = useRef(null);
	const nameRef = useRef(null);

	const history = useHistory();

	const { isOpen, onOpen, onClose } = useDisclosure();

	useEffect(() => {
		setTimeout(() => {
			if (
				firebase.auth().currentUser &&
				firebase.auth().currentUser.email
			) {
				onOpen();
			}
		}, 1500);
	}, []);

	// if the user's logged in redirect them to /

	const handleSubmit = e => {
		e.preventDefault();

		const email = emailRef.current.value;
		if (!validateEmail(email))
			return toast({
				title: "Incorrect Email",
				description: "Please enter a valid email",
				isClosable: true,
				status: "error",
			});

		const password = passwordRef.current.value;
		const name = nameRef.current.value;

		if (password.length < 5)
			return toast({
				title: "Password Too Weak",
				description: "Please enter a longer password",
				isClosable: true,
				status: "error",
			});

		if (name.length < 2)
			return toast({
				title: "Name too short",
				description: "Names have to have at least 2 characters.",
				isClosable: true,
				status: "error",
			});

		firebase
			.auth()
			.createUserWithEmailAndPassword(email, password)
			.then(() => {
				firebase
					.auth()
					.currentUser.updateProfile({ displayName: name });

				// firebase
				// 	.firestore()
				// 	.collection("users")
				// 	.doc(user.uid)
				// 	.set({ name });

				toast({
					title: "Account Created!",
					description: "You've successfully registered!",
					status: "success",
					isClosable: true,
				});
				history.push("/main");
			})
			.catch(error => {
				console.log(error);
				toast({
					title: "Duplicate Email",
					description: "An account with that email already exists",
					status: "error",
					isClosable: true,
				});
			});
	};

	return (
		<>
			<Modal isOpen={isOpen} onClose={onClose} isCentered>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>You're already logged in</ModalHeader>
					<ModalCloseButton />
					<ModalBody pr={12} py={5}>
						<Text>
							If you wish to proceed, just close this modal.
							Otherwise, press the button below to continue to the
							main site.
						</Text>
					</ModalBody>

					<ModalFooter>
						<Button
							colorScheme={theme.colours.accent}
							mr={3}
							onClick={() => history.push("/main")}
						>
							Go To Dashboard
						</Button>
						<Button
							variant="ghost"
							outlineColor={theme.colours.accent}
							onClick={onClose}
						>
							Continue
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
			<Box d="flex">
				<Box
					display={["none", "none", "none", "flex"]}
					w="130%"
					height="100vh"
					backgroundColor={theme.colours.white}
					flexDir="column"
					alignItems="center"
					justifyContent="center"
				>
					<Heading
						mb="3rem"
						bgGradient={theme.gradients.default}
						bgClip="text"
					>
						Join the community!
					</Heading>
					<Img
						w="500"
						h="480"
						src="https://firebasestorage.googleapis.com/v0/b/kyoi-dev.appspot.com/o/Public%2FLogin_Background.jpg?alt=media&token=2b92895e-f8c4-4021-b55e-2059efc3f36c"
					></Img>
				</Box>
				<Box
					w="100%"
					height="100vh"
					backgroundColor="gray.50"
					d="flex"
					flexDir="column"
					alignItems="center"
					justifyContent="center"
				>
					<Heading
						mb="3rem"
						bgGradient={theme.gradients.default}
						bgClip="text"
					>
						Register
					</Heading>
					<Box width={["80%", "80%", "80%", "60%"]}>
						<form
							onSubmit={handleSubmit}
							style={{
								width: "100%",
								display: "flex",
								justifyContent: "center",
								flexDirection: "column",
								alignItems: "center",
							}}
						>
							<FormControl id="email" mb="10">
								<FormLabel fontWeight="bold">Email</FormLabel>
								<Input
									focusBorderColor={
										theme.colours.accent + ".400"
									}
									placeholder="johndoe@example.com"
									type="email"
									autoFocus
									py={6}
									ref={emailRef}
								/>
							</FormControl>
							<FormControl id="name" mb="10">
								<FormLabel fontWeight="bold">
									Full Name
								</FormLabel>
								<Input
									focusBorderColor={
										theme.colours.accent + ".400"
									}
									placeholder="Jimi Hendrix"
									py={6}
									type="text"
									ref={nameRef}
								/>
							</FormControl>
							<FormControl id="password" mb="4">
								<FormLabel fontWeight="bold">
									Password
								</FormLabel>
								<Input
									focusBorderColor={
										theme.colours.accent + ".400"
									}
									placeholder="lahacksplases"
									py={6}
									type="password"
									ref={passwordRef}
								/>
							</FormControl>
							<Text mb="7">
								Already have an account?{" "}
								<Link
									color={theme.colours.accent + ".400"}
									as={RouterLink}
									to="/login"
								>
									Log in
								</Link>
							</Text>
							<Button
								colorScheme="purple"
								px={10}
								type="submit"
								py={6}
								bgGradient={theme.gradients.default}
							>
								Register
							</Button>
						</form>
					</Box>
				</Box>
			</Box>
		</>
	);
};
